import React, { useEffect, useRef } from 'react';
import { useProCalculator } from '../hooks/useProCalculator';
import SectionHelp from './SectionHelp';
import '../styles/CookieRowsSection.css';

const CookieRowsSection = () => {
  const {
    cookieRows,
    updateCookieRow,
    addCookieRow,
    removeCookieRow,
    isMobile,
    goToNextSection,
    activeSection
  } = useProCalculator();

  // Refs for input elements and previous row count
  const inputRefs = useRef({});
  const prevCookieRowsLengthRef = useRef(cookieRows.length);

  useEffect(() => {
    // Check if a row was added
    if (cookieRows.length > prevCookieRowsLengthRef.current) {
      const newRow = cookieRows[cookieRows.length - 1]; // Assuming new row is always last
      if (newRow && inputRefs.current[newRow.id]) {
        inputRefs.current[newRow.id].focus();
      }
    }
    // Update the ref for the next render
    prevCookieRowsLengthRef.current = cookieRows.length;
  }, [cookieRows]); // Depend on cookieRows to run when it changes

  return (
    <div className="cookie-names-section">
      {/* Header with title only */}
      <div className="section-header">
        <h2 className="section-title">Cookie Names</h2>
      </div>

      {/* Help text container */}
      <div className="section-help-container">
        <SectionHelp sectionId="cookieNames" isMobile={isMobile} />
      </div>
      
      <div className="cookie-rows">
        {cookieRows.map((row) => (
          <div key={row.id} className="cookie-row">
            <input
              type="text"
              value={row.cookieName} 
              placeholder="Enter Cookie Name" 
              onChange={(e) => {
                updateCookieRow(row.id, 'cookieName', e.target.value);
              }}
              className="cookie-name-input"
              ref={(el) => (inputRefs.current[row.id] = el)} // Assign ref
            />
            {/* Delete Button */}
            <button 
              onClick={() => removeCookieRow(row.id)}
              className="delete-row-button" 
              title="Remove Row"
              disabled={cookieRows.length <= 1} 
              style={{ visibility: cookieRows.length <= 1 ? 'hidden' : 'visible' }} 
            >
              {/* Minus Icon */}
              <span className="minus-icon">-</span>
            </button>
            {/* Add Row Button */}
            <button 
              onClick={() => {
                addCookieRow();
              }} 
              className="add-row-button" 
              title="Add Row"
            >
              <span className="plus-icon">+</span>
            </button>
          </div>
        ))}
      </div>
      
      {/* Next section button */}
      {activeSection !== 'all' && (
        <button
          className="next-section-button"
          onClick={() => goToNextSection('cookieNames')}
        >
          Next: Sets
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14"></path>
            <path d="M12 5l7 7-7 7"></path>
          </svg>
        </button>
      )}
    </div>
  );
};

export default CookieRowsSection;
